import React from 'react';
import Header from '../components/Header';

const حولالتطبيق = () => {
  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#2B2F3F',
      overflow: 'hidden',
      direction: 'rtl'
    }}>
      <Header />
      <div style={{ 
        flex: 1, 
        padding: '32px', 
        backgroundColor: '#2B2F3F', 
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '60px 40px',
          border: '1px solid rgba(233, 106, 58, 0.15)',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
          boxSizing: 'border-box',
          maxWidth: '800px',
          width: '100%',
          textAlign: 'center'
        }}>
          {/* Logo */}
          <div style={{
            width: '120px',
            height: '120px',
            margin: '0 auto 32px',
            borderRadius: '50%',
            backgroundColor: 'rgba(233, 106, 58, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#E96A3A" strokeWidth="2">
              <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          </div>

          <h1 style={{
            fontFamily: 'El Messiri, sans-serif',
            fontSize: '32px',
            fontWeight: 700,
            color: '#2B2F3F',
            margin: '0 0 12px 0'
          }}>
            Min Bayty
          </h1>

          <p style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '14px',
            color: '#666A7A',
            margin: '0 0 40px 0'
          }}>
            الإصدار 1.0.0 (Build 1)
          </p>

          <p style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#2B2F3F',
            marginBottom: '40px',
            textAlign: 'right'
          }}>
            تطبيق Min Bayty هو منصة شاملة لطلب الطعام والمنتجات من المطاعم والمتاجر المحلية. نوفر لك تجربة سهلة وسريعة للوصول إلى أفضل المطاعم والمنتجات في منطقتك.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginTop: '40px'
          }}>
            <div style={{
              padding: '20px',
              backgroundColor: '#F9F9F9',
              borderRadius: '12px',
              border: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontSize: '24px',
                marginBottom: '8px'
              }}>📧</div>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '4px'
              }}>البريد الإلكتروني</div>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#2B2F3F'
              }}>info@minbayty.com</div>
            </div>

            <div style={{
              padding: '20px',
              backgroundColor: '#F9F9F9',
              borderRadius: '12px',
              border: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontSize: '24px',
                marginBottom: '8px'
              }}>📱</div>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '4px'
              }}>الهاتف</div>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#2B2F3F'
              }}>+966 50 123 4567</div>
            </div>

            <div style={{
              padding: '20px',
              backgroundColor: '#F9F9F9',
              borderRadius: '12px',
              border: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontSize: '24px',
                marginBottom: '8px'
              }}>🌐</div>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '4px'
              }}>الموقع الإلكتروني</div>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#2B2F3F'
              }}>www.minbayty.com</div>
            </div>
          </div>

          <p style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '12px',
            color: '#999',
            marginTop: '40px',
            textAlign: 'center'
          }}>
            © {new Date().getFullYear()} Min Bayty. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </div>
  );
};

export default حولالتطبيق;




